// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomGenericResponse
 */
export interface ClassroomGenericResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassroomGenericResponse
     */
    message: string;
}

export function ClassroomGenericResponseFromJSON(json: any): ClassroomGenericResponse {
    return {
        'message': json['message'],
    };
}

export function ClassroomGenericResponseToJSON(value?: ClassroomGenericResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'message': value.message,
    };
}


